// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ButtonsGroup_wrap__slNB1","btn":"ButtonsGroup_btn__1jMCe"};